export const DATE_RANGE_PRESET = {
  TODAY: "today",
  YESTERDAY: "yesterday",
  LAST_1_DAY: "last-1-day",
  LAST_3_DAYS: "last-3-days",
  LAST_7_DAYS: "last-7-days",
  LAST_14_DAYS: "last-14-days",
  LAST_30_DAYS: "last-30-days",
  CUSTOM_FIXED: "custom-fixed",
  CUSTOM_RELATIVE: "custom-relative",
  CUSTOM_UNTIL_NOW: "custom-until-now",
} as const

export type DateRangePreset =
  (typeof DATE_RANGE_PRESET)[keyof typeof DATE_RANGE_PRESET]

export interface DateRange {
  start: Date
  end: Date
}

/**
 * A hand-picked range: either fixed at both ends, or anchored at a start and
 * running to whenever it is read. Dashboards store the distinction, so a saved
 * "since the 3rd" window keeps tracking rather than freezing at save time.
 */
export interface CustomDateRange {
  type: "fixed" | "from-date-until-now"
  startDate: Date
  endDate?: Date
  displayLabel: string
}

export type DateRangeUnit = "days" | "weeks" | "months"
